import React from "react";
import { ContactEmailModel, CustomerModel } from "@attelas/shared";
import { Chip, Grid2 as Grid, Tooltip, Typography } from "@mui/material";

type Props = {
  contactDetails: ContactEmailModel[];
};

const MultipleContactDetails = ({ contactDetails }: Props) => {
  return (
    <Grid container={true} alignItems="center" justifyContent="end" flexWrap="nowrap" sx={{ minWidth: 0 }}>
      <Grid mr={0.5} display="flex" flexWrap="wrap" justifyContent="end" gap={0.5} sx={{ minWidth: 0 }}>
        {contactDetails.map((contact) => (
          <Tooltip title={contact.description} key={contact.email}>
            <Chip
              key={contact.email}
              label={
                <Typography variant="body1" fontSize="12px">
                  {contact.email}
                </Typography>
              }
              size="small"
              sx={{
                maxWidth: "100%",
                height: "auto",
                "& .MuiChip-label": {
                  display: "block",
                  whiteSpace: "normal",
                  overflowWrap: "anywhere",
                  paddingY: "2px",
                },
              }}
            />
          </Tooltip>
        ))}
      </Grid>
    </Grid>
  );
};

export default MultipleContactDetails;
